import { render, staticRenderFns } from "./NotificationUpload.vue?vue&type=template&id=3207f2bd"
import script from "./NotificationUpload.vue?vue&type=script&lang=js"
export * from "./NotificationUpload.vue?vue&type=script&lang=js"
import style0 from "./NotificationUpload.vue?vue&type=style&index=0&id=3207f2bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports